// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2OVEN","label":"Labeled_label__3eaBK","divider":"Labeled_divider__2t4N4"};